import { render, staticRenderFns } from "./Layout_Home.vue?vue&type=template&id=b2316d48"
import script from "./Layout_Home.vue?vue&type=script&lang=js"
export * from "./Layout_Home.vue?vue&type=script&lang=js"
import style0 from "./Layout_Home.vue?vue&type=style&index=0&id=b2316d48&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports